import { Box, DataCard } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import ActionButton from '../AcceptBonusButton';
import BonusCountdownTimer from '../BonusCountdownTimer';
import RemainFreeSpinsProgressBar from '../RemainFreeSpinsProgressBar';
import WagerProgressBar from '../WagerProgressBar';
import CardContent from './components/CardContent';

import styles from './index.module.css';

export const BonusCard = ({
  bonus,
  onAccept,
  isShowButton,
  buttonTitle,
  progressBarStatus,
  isWagerEnabled,
  status,
  countdownTimerTitle,
  isCountdownTimerEnabled,
  isActivation,
  openDetails,
  detailsList,
  bonusName,
  bonusModelId,
  imageUrl,
  expireTime,
  isRequestProcessing,
  isReleased,
  classNames = {},
  actionButtonActionType,
  bonusType,
  intent,
  children,
  cardType
}) => {
  const { f } = useI18n();
  const {
    labelContainer = '',
    labelText = '',
    actionButton = '',
    bonusCard = ''
  } = classNames;

  return (
    <DataCard
      className={`${styles.bonusCard} ${
        !isWagerEnabled && !isShowButton ? styles.trimCard : ''
      } ${bonusCard}`}
      onClick={openDetails}
      dataRole="bonus-card"
    >
      <>
        <CardContent
          status={status}
          imageUrl={imageUrl}
          name={bonusName}
          id={bonusModelId}
          detailsList={detailsList}
          classNames={{ labelContainer, labelText }}
          isBonusDetailsLinkVisible={Boolean(openDetails)}
          bonusType={bonusType}
          cardType={cardType}
        />
        <Box direction="column" className={styles.wagerTimer}>
          {isCountdownTimerEnabled && expireTime?.ms && (
            <BonusCountdownTimer
              time={expireTime.ms - f.getDateTime().toMillis()}
              title={countdownTimerTitle}
            />
          )}
          <WagerProgressBar
            bonus={bonus}
            isWagerEnabled={isWagerEnabled}
            status={progressBarStatus}
          />
          {isReleased && (
            <RemainFreeSpinsProgressBar
              bonus={bonus}
              status={progressBarStatus}
            />
          )}
        </Box>
        <Box align="center" justify="end" className={styles.rightBlock}>
          {isShowButton && (
            <div className={styles.bonusActionButtonContainer}>
              <ActionButton
                onClick={onAccept}
                status={status}
                title={buttonTitle}
                isActivation={isActivation}
                isRequestProcessing={isRequestProcessing}
                className={actionButton}
                actionType={actionButtonActionType}
                intent={intent}
              />
            </div>
          )}
          {openDetails && (
            <div
              data-testid="open-details-icon"
              className={styles.detailsLinkBlock}
            >
              <Icon size="l" name="icons/general/nav/go-to" color="po_line_1" />
            </div>
          )}
        </Box>
        {children}
      </>
    </DataCard>
  );
};
